import "./manage.js";
import "./manage.less";
import "../merchantConfigShared.less";



// WEBPACK FOOTER //
// ./src/pages/merchantConfig/merchantConfigManage/index.js